import { reduxForm, change, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import {fetchReasons, createReason, editReason, deleteReason, selectReason, resetCurrentReason} from "../../actions/adjustmentInventory_actions";
import AdjustInventoryForm from "../../components/Inventories/adjustInventoryForm";

const validate = values => {
    const errors = {};
    if (!values.ReasonDesc) {
        errors.ReasonDesc = `Please Enter A Reason.`;
    }
    return errors;
}

let adjustInventoryForm = reduxForm({
    form: 'adjustInventoryForm',
    validate,
})(AdjustInventoryForm);

const selector = formValueSelector('adjustInventoryForm');

function mapStateToProps(state) {
    return {
        isEditing: state.adjustment.isEditing,
        isLoading: state.adjustment.isLoading,
        isDeleting: state.adjustment.isDeleting,
        createError: state.adjustment.createError,
        editingError: state.adjustment.editingError,
        deletionError: state.adjustment.deletionError,
        edited: state.adjustment.edited,
        created: state.adjustment.created,
        deleted: state.adjustment.deleted,
        error: state.adjustment.error,
        reason: state.adjustment.reason,
        initialValues: state.adjustment.reason
    }
}

export default connect(mapStateToProps, {
    fetchReasons,
    createReason,
    editReason,
    deleteReason,
    selectReason,
    resetCurrentReason
})(adjustInventoryForm);


// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/adjustInventoryForm.jsx